export default "__VITE_ASSET__d67cd67b__"